import css from 'styled-jsx/css'

type RadioButtonProps = {
  isHorizontal?: boolean
  propertyName: string
  values: string[]
  selectedProperty: string
  onPropertyChanged: (property: string) => void
}

export default function RadioButton({
  isHorizontal = true,
  propertyName,
  values,
  selectedProperty,
  onPropertyChanged
}: RadioButtonProps) {
  return (
    <div className={`radio-buttons field ${isHorizontal ? 'is-horizontal' : ''}`}>
      <style jsx global>
        {globalStyle}
      </style>
      <div className="field-label is-normal">
        <label className="label is-capitalized has-text-left">{propertyName}</label>
      </div>
      <div className="field-body">
        <div className="field is-grouped is-grouped-multiline">
          {values.map((value, idx) => (
            <div key={idx} className="control">
              <a
                className={`button is-capitalized' ${
                  values[idx] === selectedProperty ? 'is-active' : 'is-inactive'
                }`}
                onClick={() => onPropertyChanged(values[idx])}
              >
                {value}
              </a>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

const globalStyle = css.global`
  .radio-buttons {
    .field.is-grouped {
      .control {
        max-width: 100%;

        &:not(:last-child) {
          margin-right: 5px;
        }

        .button {
          max-width: 100%;
          text-align: justify;
          white-space: normal;
          font-size: 13px;
          height: auto;
          line-height: 18px;
          min-width: 40px;
          padding: 10px;
        }
      }

      &.is-grouped-multiline {
        .control:not(:last-child) {
          margin-bottom: 5px;
        }
      }
    }
  }
`
